export enum EstimationType {
  any = 'any',
  storyPoints = 'storyPoints',
  hours = 'hours'
}
